<template>
  <div class="case-item" @click="bindClick">
    <div class="item-top">
      <img class="item-avatar" :src="data.user_head" alt="" />
      <div class="item-t-center">
        <div class="nickname">{{ data.truename }}</div>
        <div class="class-name">{{ data.product_alias_name }}</div>
      </div>
      <div class="item-btn">查看详情</div>
    </div>
    <div class="item-info">
      <div class="info-item info-item-1">
        <div class="info-item-left">
          <div class="info-item-text">打卡</div>
          <div class="info-item-unit">(次数)</div>
        </div>
        <div class="info-item-num">{{ data.clock_time }}</div>
      </div>
      <div class="info-item info-item-2">
        <div class="info-item-left">
          <div class="info-item-text">体重</div>
          <div class="info-item-unit">(斤)</div>
        </div>
        <div class="info-item-num"
          ><span
            class="iconfont icon-xingzhuangjiehebeifen"
            :class="{ 'up-icon': data.compare_data.lessWeight > 0 }"
          ></span
          ><span>{{ Math.abs(data.compare_data.lessWeight) }}</span></div
        >
      </div>
      <div class="info-item info-item-3">
        <div class="info-item-left">
          <div class="info-item-text">腰围</div>
          <div class="info-item-unit">(厘米)</div>
        </div>
        <div class="info-item-num"
          ><span
            class="iconfont icon-xingzhuangjiehebeifen"
            :class="{ 'up-icon': data.compare_data.lessWaist > 0 }"
          ></span
          ><span>{{ Math.abs(data.compare_data.lessWaist) }}</span></div
        >
      </div>
    </div>
    <div class="image-list">
      <div class="image-item">
        <div class="flag flag-before">入营前</div>
        <img class="image" :src="data.start_img.start_img_1" alt="" />
      </div>
      <div class="image-item">
        <div class="flag flag-after">入营后</div>
        <img class="image" :src="data.end_img.end_img_1" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClick() {
      this.$router.push({
        path: '/case-detail',
        query: {
          id: this.data.id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.case-item {
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 4px;
  width: 291px;
  padding: 12px 10px 10px;
  .item-top {
    display: flex;
    align-items: center;
    margin-bottom: 13px;
    .item-avatar {
      border-radius: 4px;
      width: 36px;
      height: 36px;
      object-fit: cover;
      margin-right: 8px;
    }
    .item-t-center {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      .nickname {
        font-weight: bold;
        font-size: 12px;
        color: rgba(48, 48, 56, 0.8);
        line-height: 17px;
      }
      .class-name {
        font-size: 10px;
        color: rgba(48, 48, 56, 0.5);
        line-height: 14px;
      }
    }
    .item-btn {
      margin-left: 8px;
      box-sizing: border-box;
      width: 55px;
      height: 23px;
      border-radius: 12px;
      border: 0.5px solid #303038;
      font-weight: bold;
      font-size: 10px;
      color: #303038;
      line-height: 23px;
      text-align: center;
    }
  }
  .item-info {
    display: flex;
    align-items: center;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 5px 0px;
    margin-bottom: 13px;
    .info-item {
      box-sizing: border-box;
      padding-left: 10px;
      flex-shrink: 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      .info-item-left {
        text-align: center;
        font-weight: bold;
        margin-right: 4px;
        color: rgba(0, 0, 0, 0.5);
        .info-item-text {
          white-space: nowrap;
          font-size: 12px;
        }
        .info-item-unit {
          white-space: nowrap;
          font-size: 10px;
        }
      }
      .info-item-num {
        white-space: nowrap;
        font-family: DIN;
        font-weight: bold;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 24px;
        display: flex;
        align-items: center;
        .iconfont {
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgba(36, 199, 137, 1);
          font-size: 12px;
          margin-right: 3px;
        }
        .up-icon {
          color: red;
          transform: rotate(180deg);
        }
      }
    }
    .info-item-1 {
      flex: 0 0 78px;
    }
    .info-item-2 {
      flex: 0 0 92px;
    }
    .info-item-3 {
      flex: 0 0 102px;
    }
  }
  .image-list {
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    .image-item {
      width: 50%;
      height: 179px;
      position: relative;
      .flag {
        position: absolute;
        top: 0;
        width: 60px;
        height: 22px;
        background: rgba(48, 48, 56, 0.6);
        border-radius: 4px 0px 4px 0px;
        font-weight: bold;
        font-size: 12px;
        color: #ffffff;
        line-height: 22px;
        text-align: center;
      }
      .flag-before {
        left: 0;
      }
      .flag-after {
        right: 0;
        background-color: rgba(36, 199, 137, 1);
        border-radius: 0px 4px 0px 4px;
      }
      .image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
